"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeaderEditable = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var EditableLabelWithBubble_1 = require("./EditableLabelWithBubble");
var sectionHeaderHelper_1 = require("./sectionHeaderHelper");
var model_1 = require("../../../../model");
function SectionHeaderEditable(props) {
    var description = sectionHeaderHelper_1.getDescription(props.description);
    var title = sectionHeaderHelper_1.getTitle(props.title);
    var index = props.index;
    var intl = react_intl_1.useIntl();
    var dispatch = model_1.useDashboardDispatch();
    var changeTitle = react_1.useCallback(function (title) { return dispatch(model_1.changeLayoutSectionHeader(index, { title: title }, true)); }, [dispatch, index]);
    var changeDescription = react_1.useCallback(function (description) { return dispatch(model_1.changeLayoutSectionHeader(index, { description: description }, true)); }, [dispatch, index]);
    var onEditingStart = react_1.useCallback(function () {
        dispatch(model_1.uiActions.setActiveSectionIndex(index));
    }, [dispatch, index]);
    var onEditingEnd = react_1.useCallback(function () {
        dispatch(model_1.uiActions.clearActiveSectionIndex());
    }, [dispatch]);
    var onTitleSubmit = react_1.useCallback(function (title) {
        changeTitle(title);
        onEditingEnd();
    }, [changeTitle, onEditingEnd]);
    var onDescriptionSubmit = react_1.useCallback(function (description) {
        changeDescription(description);
        onEditingEnd();
    }, [changeDescription, onEditingEnd]);
    return (react_1.default.createElement("div", { className: "gd-row-header-edit" },
        react_1.default.createElement("div", { className: "gd-editable-label-container gd-row-header-title-wrapper" },
            react_1.default.createElement(EditableLabelWithBubble_1.EditableLabelWithBubble, { className: "gd-title-for-" + index + " s-fluid-layout-row-title-input title gd-heading-2", maxRows: 10, value: title || "", maxLength: sectionHeaderHelper_1.MAX_TITLE_LENGTH, warningLimit: sectionHeaderHelper_1.TITLE_LENGTH_WARNING_LIMIT, placeholderMessage: intl.formatMessage({ id: "layout.header.add.title.placeholder" }), alignTo: ".gd-title-for-" + index, onSubmit: onTitleSubmit, onEditingStart: onEditingStart, onCancel: onEditingEnd })),
        react_1.default.createElement("div", { className: "gd-editable-label-container gd-row-header-description-wrapper" },
            react_1.default.createElement(EditableLabelWithBubble_1.EditableLabelWithBubble, { className: "gd-description-for-" + index + " s-fluid-layout-row-description-input description", alignTo: ".gd-description-for-" + index, maxRows: 15, value: description || "", maxLength: sectionHeaderHelper_1.MAX_DESCRIPTION_LENGTH, warningLimit: sectionHeaderHelper_1.DESCRIPTION_LENGTH_WARNING_LIMIT, placeholderMessage: intl.formatMessage({
                    id: "layout.header.add.description.placeholder",
                }), onSubmit: onDescriptionSubmit, onEditingStart: onEditingStart, onCancel: onEditingEnd }))));
}
exports.SectionHeaderEditable = SectionHeaderEditable;
//# sourceMappingURL=SectionHeaderEditable.js.map